import {DepotsWithHeaders, Countries, Cities, CountryDepots } from "@/assets/depots";

const state = {
  byCountry: {},
  cancelTokens: {},
  locations: DepotsWithHeaders,
  countryNames: Countries,
  searchCities: Cities,
  countryDepots: CountryDepots
};

const getters = {};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
